import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles({
	root: {
		"& .MuiInputBase-input": {
			fontFamily: "inherit",
			fontSize: 14
		}
	}
})

export default useStyles
